import { Button } from "primereact/button"

const Disclaimer = () => {
    return (
        <>
            <div className="py-5 px-6">
                <img src="/LogoWithColoredText.png" height={40}></img>
            </div>
            <div className="flex flex-column py-4 px-6 sm:px-8 " style={{ backgroundColor: "#F5F6FA" }}>
                <h1 className="text-3xl font-bold mt-4" style={{color: "#2D3967"}}>Disclaimer</h1>
                <p className="text-justify" style={{ color: "#727A99"}}>
                    Mobithera is presently undergoing clinical research studies in Türkiye. Our service is not designed to diagnose, treat, cure, or prevent any medical condition or disease. We provide exercise guidance exclusively – this platform does not serve as a replacement for professional medical care or treatment. Our system has not received clearance for making therapeutic claims within the United States. Individual outcomes and results may differ significantly.
                    <br />
                    <br />
                    {" "}<b>"User"</b> refers to any individual who accesses, uses, or interacts with the Mobithera platform, including but not limited to patients, customers, or third parties. Users engage with our service entirely at their own discretion and risk.
                    <br />
                    <br />
                    Under the fullest scope allowed by governing laws, Mobithera (hereinafter referred to as the <b>Owner</b>) explicitly rejects and disclaims any and all conditions, representations, and warranties of every kind—whether they are express, implied, statutory, or of any other nature. This includes, without limitation, any implied warranties relating to merchantability, suitability for any specific purpose, or non-violation of third-party intellectual property rights. No guidance or information, regardless of whether it is communicated verbally or in writing, that any User receives from the Owner or through our service shall establish any warranty that is not explicitly outlined in this document.
                    <br />
                    <br />
                    In addition to the above disclaimers, the Owner, along with its subsidiary companies, affiliated entities, licensors, officers, directors, representatives, co-branding partners, business partners, suppliers, and staff members, does not provide any assurance that the platform content is precise, dependable, or accurate; that our service will satisfy Users' specific needs or expectations; that our service will remain accessible at any specific time or geographic location, without interruption, or in a secure manner; that any technical issues, defects, or errors will be resolved or corrected; or that our service operates without viruses, malware, or other potentially harmful software components.
                    <br />
                    <br />
                    Any materials, content, or data downloaded or otherwise acquired through the utilization of our service is obtained entirely at the User's personal risk, and Users bear complete responsibility for any harm, damage, or malfunction to their computer systems, mobile devices, or any loss of personal data that may occur as a result of such downloads or their usage of our service.
                    <br />
                    <br />
                    Our service may experience periods of inaccessibility or may not operate correctly with Users' specific web browsers, mobile devices, and/or operating systems. The Owner cannot and will not be held responsible or liable for any perceived, alleged, or actual damages, losses, or harm that may arise from the service content, performance, and the operation of this service, or any use of this service by Users.
                    <br />
                    <br />
                    For detailed information and instructions for use for Mobithera, click <a href="/IFU.MBT.02 USA 24.07.2025.pdf" target="_blank">here.</a>
                </p>
            </div>
            <div className="flex flex-wrap justify-content-between gap-4 py-8 p-8" style={{
                width: "100%",
                minHeight: '20vh',
                backgroundColor: "#2D3967",
            }}
            >
                <div className="flex justify-content-between align-items-start">
                    <div className="flex flex-column gap-4 align-items-start">
                        <img src="/Logo.svg" height={40}></img>
                        <p className="m-0 text-md" style={{ color: "#FFFFFF" }} >
                            Unlock the power of AI with personalized <br />
                            physiotherapy programs tailored to your <br />
                            needs.
                        </p>
                    </div>
                </div>
                <div className="flex gap-4" >
                    <Button
                        style={{
                            color: "white",
                            border: "1px solid #FFFFFF",
                            backgroundColor: "transparent",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "3.5rem",
                            display: "flex",

                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/LinkedinIcon.svg" />
                        </div>
                    </Button  >
                    <Button
                        style={{
                            color: "white",
                            border: "1px solid #FFFFFF",
                            backgroundColor: "transparent",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "3.5rem",
                            display: "flex",

                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/InstagramIcon.svg" />
                        </div>
                    </Button  >
                    <Button
                        style={{
                            color: "white",
                            border: "1px solid #FFFFFF",
                            backgroundColor: "transparent",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "3.5rem",
                            display: "flex",

                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/YoutubeIcon.svg" />
                        </div>
                    </Button  >
                </div>
            </div>
            <div className="w-full flex justify-content-center align-items-center"
                style={{
                    width: "100%",
                    minHeight: "7vh",
                    backgroundColor: "#29345E",
                }}
            >
                <p className="text-sm" style={{ color: "#727A99" }}>© {new Date().getFullYear()} <span className="font-bold" style={{ color: "#FFFFFF" }}>Mobithera Technology.</span> All Rights Reserved.</p>
            </div>
        </>
    )
}

export default Disclaimer;